<template>
  <Footer>
    <nav class="tabs is-boxed is-fullwidth">
      <div class="container">
        <ul>
          <li><a :href="link_term"    target="_blank" rel="noopener">{{ $t("TopFooter.rule") }}</a></li>
          <li><a :href="link_privacy" target="_blank" rel="noopener">{{ $t("TopFooter.privacy") }}</a></li>
          <li><a :href="link_home"    target="_blank" rel="noopener">{{ $t("TopFooter.company") }}</a></li>
        </ul>
      </div>
    </nav>
  </Footer>
</template>

<script>
import Footer from '@/components/layouts/Footer'
export default {
  name: 'TopFooter',
  componentName: 'TopFooter',
  components: {
    Footer
  },
  data () {
    return {
      link_term: '/terms/',
      link_privacy: '/privacy',
      link_home: 'https://www.robottte.com/'
    }
  },
  props: {
    height: {
      type: String,
      default: 'auto'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Top/TopFooter.vue